<template>
  <div id="app">
    <!-- 顶部导航：桌面展示完整链接，移动端折叠为汉堡抽屉 -->
    <header class="site-header">
      <div class="header-inner">
        <a class="brand" title="返回首页" @click="go('1')">
          <img class="brand-logo" :src="brandLogo" alt="" />
          <span class="brand-name">闪耀星启</span>
        </a>

        <!-- 桌面导航（≥768px） -->
        <nav class="desktop-nav" role="navigation">
          <div
              v-for="item in menu"
              :key="item.key"
              class="nav-group"
              @mouseenter="openDrop = item.key"
              @mouseleave="openDrop = ''"
          >
            <template v-if="hasChildren(item)">
              <button
                  type="button"
                  class="nav-link"
                  :class="{ active: isItemActive(item), 'drop-open': openDrop === item.key }"
                  @click="openDrop = openDrop === item.key ? '' : item.key"
              >
                {{ item.label }}
                <svg class="caret" viewBox="0 0 10 6" width="10" height="6" aria-hidden="true">
                  <path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
              <transition name="drop">
                <div v-show="openDrop === item.key" class="dropdown">
                  <a
                      v-for="child in item.children"
                      :key="child.key"
                      class="dropdown-item"
                      :class="{ active: selected === child.key }"
                      @click="go(child.key)"
                  >{{ child.label }}</a>
                </div>
              </transition>
            </template>
            <a
                v-else
                class="nav-link"
                :class="{ active: selected === item.key }"
                @click="go(item.key)"
            >{{ item.label }}</a>
          </div>
        </nav>

        <!-- 移动端汉堡按钮（<768px） -->
        <button
            type="button"
            class="menu-toggle"
            :class="{ open: drawer }"
            aria-label="打开菜单"
            @click="toggleDrawer"
        >
          <span></span><span></span><span></span>
        </button>
      </div>
    </header>

    <main class="site-main">
      <component :is="currentComponent"></component>
    </main>

    <!-- 全站页脚：版权 + 备案号 -->
    <footer class="site-footer">
      <div class="footer-inner">
        <span class="beian-links">
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">{{ icpNo }}</a>
          <a href="https://beian.mps.gov.cn/" target="_blank" rel="noopener noreferrer">{{ policeNo }}</a>
        </span>
      </div>
    </footer>

    <!-- 移动端抽屉遮罩 + 面板 -->
    <transition name="fade">
      <div v-if="drawer" class="drawer-overlay" @click="drawer = false"></div>
    </transition>
    <transition name="slide">
      <aside v-if="drawer" class="drawer-panel" role="dialog" aria-label="菜单">
        <div class="drawer-top">
          <a class="brand" title="返回首页" @click="go('1')">
            <img class="brand-logo" :src="brandLogo" alt="" />
            <span class="brand-name">闪耀星启</span>
          </a>
          <button type="button" class="drawer-close" aria-label="关闭菜单" @click="drawer = false">
            <svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true">
              <path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
            </svg>
          </button>
        </div>

        <nav class="mobile-nav">
          <div v-for="item in menu" :key="item.key" class="mobile-group">
            <template v-if="hasChildren(item)">
              <button
                  type="button"
                  class="mobile-link has-sub"
                  :class="{ active: isItemActive(item), 'sub-open': openGroup === item.key }"
                  @click="openGroup = openGroup === item.key ? '' : item.key"
              >
                {{ item.label }}
                <span class="mobile-arrow">›</span>
              </button>
              <transition name="sub">
                <div v-show="openGroup === item.key" class="mobile-sub">
                  <a
                      v-for="child in item.children"
                      :key="child.key"
                      class="mobile-link sub-item"
                      :class="{ active: selected === child.key }"
                      @click="go(child.key)"
                  >{{ child.label }}</a>
                </div>
              </transition>
            </template>
            <a
                v-else
                class="mobile-link"
                :class="{ active: selected === item.key }"
                @click="go(item.key)"
            >{{ item.label }}</a>
          </div>
        </nav>
      </aside>
    </transition>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
import YqhxApp from './components/YqhxApp.vue'
import ContactUs from './components/ContactUs.vue'
import Company from './components/Company.vue'

const ROUTES = {
  '1': 'Company',
  '2-1': 'YqhxApp',
  '3': 'HelloWorld',
  '4': 'ContactUs',
  '5': 'ContactUs'
}

export default {
  name: 'App',
  components: {
    HelloWorld,
    YqhxApp,
    ContactUs,
    Company
  },
  data() {
    return {
      brandLogo: require('@/assets/img/logo.png'),
      selected: '1', // 当前选中菜单项
      currentComponent: 'Company',
      drawer: false,          // 移动端抽屉开关
      openDrop: '',           // 桌面「产品详情」下拉展开项
      openGroup: '',          // 移动端分组展开项
      icpNo: '京ICP备2023017871号',  
      policeNo: '京公网安备11011502040728号', 
      menu: [
        { label: '首页', key: '1' },
        {
          label: '产品详情',
          key: '2',
          children: [
            { label: '优启星app', key: '2-1' }
          ]
        },
        { label: '科学教研', key: '3' },
        { label: '预约购买', key: '5' },
        { label: '联系我们', key: '4' }
      ]
    }
  },
  watch: {
    drawer(open) {
      document.body.style.overflow = open ? 'hidden' : ''
    }
  },
  methods: {
    hasChildren(item) {
      return !!(item.children && item.children.length)
    },
    toggleDrawer() {
      this.drawer = !this.drawer
      // 打开时若当前选中项在某个分组下，自动展开该分组
      if (this.drawer) {
        const parent = this.menu.find(m => m.children && m.children.some(c => c.key === this.selected))
        this.openGroup = parent ? parent.key : ''
      }
    },
    // 导航项是否高亮：命中自身，或命中其分组下的子项（如选中“优启星app”时高亮“产品详情”）
    isItemActive(item) {
      if (this.selected === item.key) return true
      return !!(item.children && item.children.some(c => c.key === this.selected))
    },
    go(key) {
      this.selected = key
      this.currentComponent = ROUTES[String(key)] || 'HelloWorld'
      this.openDrop = ''
      this.drawer = false
      this.$nextTick(() => window.scrollTo(0, 0))
    }
  }
}
</script>

<!-- 全局设计变量（非 scoped） -->
<style>
:root {
  --jhy-accent: #15803d;      /* 品牌主色（健康绿） */
  --jhy-ink: #1f2937;
  --jhy-muted: #6b7280;
  --jhy-header-h: 64px;
}
html {
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
}
@media (max-width: 767px) {
  :root {
    --jhy-header-h: 56px;
  }
}
</style>

<style scoped>
#app {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

/* ================= 顶部导航 ================= */
.site-header {
  position: sticky;
  top: 0;
  z-index: 200;
  height: var(--jhy-header-h);
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: saturate(180%) blur(10px);
  border-bottom: 1px solid #eef0f3;
  box-shadow: 0 1px 8px rgba(17, 24, 39, 0.05);
}

.header-inner {
  max-width: 100%;
  height: 100%;
  margin: 0 auto;
  padding: 0 clamp(16px, 4vw, 88px);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.brand {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.brand-logo {
  width: auto;
  height: 48px;
}

.brand-name {
  margin-left: 10px;
  font-family: inherit;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 2px;
  line-height: 1;
  color: var(--jhy-ink);
  white-space: nowrap;
}

/* 移动端右侧抽屉：只显示 logo，不显示文字 */
.drawer-panel .brand-name {
  display: none;
}

/* 桌面链接 */
.desktop-nav {
  display: flex;
  align-items: center;
  gap: 6px;
}

.nav-group {
  position: relative;
  display: flex;
  align-items: center;
}

.nav-link {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 10px 14px;
  border: none;
  background: transparent;
  font-family: inherit;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.4;
  color: var(--jhy-ink);
  cursor: pointer;
  text-decoration: none;
  transition: color 0.2s ease;
}

.nav-link:hover {
  color: var(--jhy-accent);
}

.nav-link.active {
  color: var(--jhy-accent);
  font-weight: 700;
}

.nav-link.active::after {
  content: "";
  position: absolute;
  left: 14px;
  right: 14px;
  bottom: 4px;
  height: 3px;
  border-radius: 2px;
  background: var(--jhy-accent);
}

.caret {
  color: inherit;
  opacity: 0.7;
  transition: transform 0.2s ease;
}

.nav-link.drop-open .caret {
  transform: rotate(180deg);
}

/* 桌面下拉 */
.dropdown {
  position: absolute;
  top: calc(100% + 10px);
  left: 0;
  min-width: 150px;
  padding: 6px;
  background: #ffffff;
  border: 1px solid #eef0f3;
  border-radius: 10px;
  box-shadow: 0 12px 30px rgba(17, 24, 39, 0.12);
}

.dropdown-item {
  display: block;
  padding: 10px 14px;
  border-radius: 7px;
  color: var(--jhy-ink);
  font-size: 15px;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.dropdown-item:hover {
  background: #f0fdf4;
  color: var(--jhy-accent);
}

.dropdown-item.active {
  color: var(--jhy-accent);
  font-weight: 600;
}

.drop-enter-active,
.drop-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
  transform-origin: top center;
}

.drop-enter,
.drop-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

/* 汉堡按钮（默认隐藏） */
.menu-toggle {
  display: none;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  width: 44px;
  height: 44px;
  padding: 0 8px;
  border: none;
  background: transparent;
  cursor: pointer;
}

.menu-toggle span {
  display: block;
  height: 2.5px;
  width: 100%;
  border-radius: 2px;
  background: var(--jhy-ink);
  transition: transform 0.25s ease, opacity 0.25s ease;
}

.menu-toggle.open span:nth-child(1) {
  transform: translateY(7.5px) rotate(45deg);
}
.menu-toggle.open span:nth-child(2) {
  opacity: 0;
}
.menu-toggle.open span:nth-child(3) {
  transform: translateY(-7.5px) rotate(-45deg);
}

.site-main {
  min-height: calc(100vh - var(--jhy-header-h));
}

/* ================= 页脚（版权 + 备案号） ================= */
.site-footer {
  background: #f8fafc;
  border-top: 1px solid #eef0f3;
  padding: 16px clamp(16px, 4vw, 88px);
}

.footer-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 6px 20px;
  font-size: 13px;
  line-height: 1.6;
  color: var(--jhy-muted);
  text-align: center;
}

.beian-links {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 6px 20px;
}

.site-footer a {
  color: inherit;
  text-decoration: none;
  white-space: nowrap;
  transition: color 0.2s ease;
}

.site-footer a:hover {
  color: var(--jhy-accent);
}

/* ================= 移动端抽屉 ================= */
.drawer-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(15, 23, 42, 0.45);
}

.drawer-panel {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1001;
  width: 84vw;
  max-width: 340px;
  background: #ffffff;
  box-shadow: -12px 0 40px rgba(15, 23, 42, 0.16);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.drawer-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 18px;
  border-bottom: 1px solid #f1f3f5;
  flex-shrink: 0;
}

.drawer-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: none;
  background: transparent;
  color: var(--jhy-ink);
  cursor: pointer;
  border-radius: 50%;
  transition: background 0.2s ease, color 0.2s ease;
}

.drawer-close:hover {
  background: #f3f4f6;
  color: var(--jhy-accent);
}

.mobile-nav {
  padding: 10px 12px 30px;
}

.mobile-link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  padding: 15px 12px;
  border: none;
  background: transparent;
  font-family: inherit;
  font-size: 17px;
  color: var(--jhy-ink);
  text-decoration: none;
  text-align: left;
  cursor: pointer;
  border-radius: 10px;
  transition: background 0.2s ease, color 0.2s ease;
}

.mobile-link:active {
  background: #f3f4f6;
}

.mobile-link.active {
  color: var(--jhy-accent);
  font-weight: 700;
}

.mobile-link.has-sub.active {
  font-weight: 600;
}

.mobile-arrow {
  font-size: 20px;
  line-height: 1;
  color: #9ca3af;
  transition: transform 0.2s ease;
}

.mobile-link.sub-open .mobile-arrow {
  transform: rotate(90deg);
  color: var(--jhy-accent);
}

.mobile-sub {
  padding-left: 16px;
  border-left: 2px solid #e5e7eb;
  margin-left: 16px;
}

.mobile-sub .sub-item {
  padding: 12px 14px;
  font-size: 15px;
  color: #4b5563;
}

.sub-enter-active,
.sub-leave-active {
  transition: opacity 0.2s ease;
}

.sub-enter,
.sub-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.28s ease;
}

.slide-enter,
.slide-leave-to {
  transform: translateX(100%);
}

/* ================= 响应式断点 ================= */
@media (max-width: 900px) {
  .header-inner {
    padding: 0 16px;
  }
}

@media (max-width: 767px) {
  .desktop-nav {
    display: none;
  }

  .menu-toggle {
    display: flex;
  }

  .brand-logo {
    height: 40px;
  }

  .brand-name {
    font-size: 20px;
    margin-left: 8px;
    letter-spacing: 1px;
  }
}
</style>
